import React from 'react'
import { Bar } from 'react-chartjs-2'
import { Spinner } from 'react-bootstrap'
import { ChartData, ChartOptions } from 'chart.js'
import { StatsSection, SectionTitle, DetailCard, DetailHeader, ChartContainer } from '../styles'
import { FaChartBar } from 'react-icons/fa'

interface ChartSectionProps {
  title: string
  data: ChartData<'bar'>
  options: ChartOptions<'bar'>
  isLoading: boolean
}

export const ChartSection: React.FC<ChartSectionProps> = ({ title, data, options, isLoading }) => {
  return (
    <StatsSection>
      <SectionTitle>
        <FaChartBar /> {title}
      </SectionTitle>
      <DetailCard>
        <DetailHeader>
          <h3>Images & Annotations by Dataset</h3>
        </DetailHeader>
        <DetailCard.Body>
          <ChartContainer>
            {isLoading ? (
              <div className="loading-overlay">
                <Spinner animation="border" variant="primary" />
              </div>
            ) : (
              <Bar data={data} options={options} />
            )}
          </ChartContainer>
        </DetailCard.Body>
      </DetailCard>
    </StatsSection>
  )
}
